import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/i18n';
import './index.css';
import App from './App';
import { registerServiceWorker } from '../../shared/utils/registerServiceWorker';
import { hideSplash, setStatusBarStyle, isNative } from '../../shared/utils/native';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (process.env.NODE_ENV === 'production') {
  registerServiceWorker(`${process.env.PUBLIC_URL || ''}/service-worker.js`);
}

// Phase 2 / Step H — Capacitor bring-up hooks. No-op on web; on iOS
// these set the dark status-bar text + hide the launch splash once
// React is mounted. We call after a tick so the first paint is on
// screen before iOS dismisses the splash.
if (isNative()) {
  setStatusBarStyle({ style: 'dark' }).catch(() => {});
  setTimeout(() => hideSplash().catch(() => {}), 100);
}

